import { GridColDef } from '@mui/x-data-grid';

export const pointSettingListColumns: GridColDef[] = [
  {
    flex: 1,
    minWidth: 100,
    field: 'code',
    headerName: 'code',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },

  {
    minWidth: 50,
    field: 'season',
    headerName: 'season',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },

  {
    flex: 1,
    minWidth: 50,
    field: 'totUserJoin',
    headerName: '최대 참여인원',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },

  {
    flex: 1,
    minWidth: 50,
    field: 'referralReceivedMax',
    headerName: '추천인 최대 수',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },

  {
    flex: 1,
    minWidth: 50,
    field: 'referralReceived',
    headerName: '추천인 포인트',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },

  {
    flex: 1,
    minWidth: 50,
    field: 'referralJoin',
    headerName: '피추천인 포인트',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },

  {
    flex: 1,
    minWidth: 50,
    field: 'dayParticipationCnt',
    headerName: '일일 참여 카운트',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },

  {
    flex: 1,
    minWidth: 50,
    field: 'statusFillter',
    headerName: '상태',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },

  {
    flex: 1,
    minWidth: 50,
    field: 'regDt',
    headerName: '등록일',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
];

export const pointUserListColumns: GridColDef[] = [
  {
    flex: 1,
    minWidth: 200,
    field: 'id',
    headerName: 'id',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },

  {
    flex: 1,
    minWidth: 200,
    field: 'address',
    headerName: 'address',
    headerAlign: 'center',
    align: 'left',
    sortable: false,
  },

  {
    minWidth: 100,
    field: 'referralCode',
    headerName: '추천코드',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },

  {
    flex: 1,
    minWidth: 20,
    field: 'totCount',
    headerName: '참여횟수',
    sortable: false,
    headerAlign: 'center',
    align: 'right',
  },

  {
    flex: 1,
    minWidth: 20,
    field: 'totPoint',
    headerName: '누적포인트',
    sortable: false,
    headerAlign: 'center',
    align: 'right',
  },

  {
    flex: 1,
    minWidth: 20,
    field: 'totReferralPoint',
    headerName: '레퍼럴포인트(추천인)',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    flex: 1,
    minWidth: 20,
    field: 'totBonusPoint',
    headerName: '보너스포인트',
    sortable: false,
    headerAlign: 'center',
    align: 'right',
  },
  {
    flex: 1,
    minWidth: 30,
    field: 'total',
    headerName: '포인트합계',
    sortable: false,
    headerAlign: 'center',
    align: 'right',
  },
  {
    flex: 1,
    minWidth: 50,
    field: 'customReferralCnt',
    headerName: '커스텀 레퍼럴',
    sortable: false,
    headerAlign: 'center',
    align: 'right',
  },
  {
    flex: 1,
    minWidth: 50,
    field: 'regDt',
    headerName: '가입일',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
];

export const pointUserLedgerListColumns: GridColDef[] = [
  {
    minWidth: 200,
    field: 'id',
    headerName: 'id',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },

  {
    flex: 1,
    minWidth: 200,
    field: 'address',
    headerName: 'address',
    headerAlign: 'center',
    align: 'left',
    sortable: false,
  },

  {
    minWidth: 100,
    field: 'code',
    headerName: 'code',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 20,
    field: 'season',
    headerName: 'season',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },

  {
    minWidth: 150,
    field: 'amount',
    headerName: 'amount',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 100,
    field: 'status',
    headerName: 'status',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },

  {
    minWidth: 100,
    field: 'referralCode',
    headerName: '추천인코드',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },

  {
    minWidth: 200,
    field: 'regDt',
    headerName: 'regDt',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },

  {
    flex: 1,
    minWidth: 200,
    field: 'memo',
    headerName: 'memo',
    headerAlign: 'center',
    align: 'left',
    sortable: false,
  },
];

export const pointUserDetailListColumns: GridColDef[] = [
  {
    minWidth: 150,
    field: 'amount',
    headerName: 'amount',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 100,
    field: 'status',
    headerName: 'status',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },

  {
    minWidth: 200,
    field: 'regDt',
    headerName: 'regDt',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },

  {
    flex: 1,
    minWidth: 200,
    field: 'memo',
    headerName: 'memo',
    headerAlign: 'center',
    align: 'left',
    sortable: false,
  },
];

export const PointStakeSettingListColumns: GridColDef[] = [
  {
    minWidth: 200,
    field: 'title',
    headerName: '제목',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },

  {
    minWidth: 200,
    field: 'startDt',
    headerName: '시작날짜',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },

  {
    minWidth: 200,
    field: 'endDt',
    headerName: '종료날짜',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },

  {
    minWidth: 200,
    field: 'rewardDt',
    headerName: '이자지급일',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },

  {
    minWidth: 200,
    field: 'interestRate',
    headerName: '연이자',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },

  {
    minWidth: 200,
    field: 'usdt',
    headerName: 'usdt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },

  {
    minWidth: 200,
    field: 'regDt',
    headerName: '등록일',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
];

export const BetGameTypeListColumns: GridColDef[] = [
  {
    flex: 1,
    minWidth: 200,
    field: 'name',
    headerName: '이름',
    sortable: false,
    headerAlign: 'center',
    align: 'left',
  },
  {
    flex: 1,
    minWidth: 200,
    field: 'totAmount',
    headerName: '총 금액',
    sortable: false,
    headerAlign: 'center',
    align: 'right',
  },

  {
    flex: 1,
    minWidth: 200,
    field: 'minTotAmount',
    headerName: '최소금액(사용방법 미정)',
    sortable: false,
    headerAlign: 'center',
    align: 'right',
  },
  {
    flex: 1,
    minWidth: 200,
    field: 'type',
    headerName: '타입',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    minWidth: 200,
    field: 'regDt',
    headerName: '등록일',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
];

export const BetSwapListColumns: GridColDef[] = [
  {
    minWidth: 200,
    field: 'swapId',
    headerName: 'swapId',
    sortable: false,
    headerAlign: 'center',
    align: 'left',
  },
  {
    flex: 1,
    minWidth: 200,
    field: 'address',
    headerName: 'address',
    sortable: false,
    headerAlign: 'center',
    align: 'left',
  },

  {
    minWidth: 100,
    field: 'symbol',
    headerName: 'symbol',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },

  {
    minWidth: 200,
    field: 'tokenAmount',
    headerName: '토큰 수량',
    sortable: false,
    headerAlign: 'center',
    align: 'right',
  },

  {
    minWidth: 200,
    field: 'betAmount',
    headerName: '베팅 포인트',
    sortable: false,
    headerAlign: 'center',
    align: 'right',
  },

  {
    minWidth: 250,
    field: 'hash',
    headerName: 'hash',
    sortable: false,
    headerAlign: 'center',
    align: 'left',
  },

  {
    minWidth: 200,
    field: 'typeName',
    headerName: '타입',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },

  {
    minWidth: 200,
    field: 'statusName',
    headerName: '상태',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },

  {
    minWidth: 200,
    field: 'ticker',
    headerName: '시세',
    sortable: false,
    headerAlign: 'center',
    align: 'right',
  },

  {
    minWidth: 200,
    field: 'regDt',
    headerName: '등록일',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
];

export const BetUserListColumns: GridColDef[] = [
  {
    flex: 1,
    minWidth: 200,
    field: 'address',
    headerName: 'address',
    sortable: false,
    headerAlign: 'center',
    align: 'left',
  },

  {
    flex: 1,
    minWidth: 100,
    field: 'totalAmount',
    headerName: 'total',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    minWidth: 200,
    field: 'regDt',
    headerName: '등록일',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
];

export const betUserLedgerListColumns: GridColDef[] = [
  {
    flex: 1,
    minWidth: 200,
    field: 'address',
    headerName: 'address',
    sortable: false,
    headerAlign: 'center',
    align: 'left',
  },
  {
    minWidth: 200,
    field: 'amount',
    headerName: 'amount',
    sortable: false,
    headerAlign: 'center',
    align: 'right',
  },
  {
    minWidth: 100,
    field: 'typeName',
    headerName: 'type',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    minWidth: 200,
    field: 'statusName',
    headerName: 'status',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },

  {
    minWidth: 200,
    field: 'regDt',
    headerName: 'regDt',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    flex: 1,
    minWidth: 200,
    field: 'memo',
    headerName: 'memo',
    sortable: false,
    headerAlign: 'center',
    align: 'left',
  },
];

export const versionListColumns: GridColDef[] = [
  {
    flex: 1,
    minWidth: 200,
    field: 'name',
    headerName: 'name',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    flex: 1,
    minWidth: 200,
    field: 'version',
    headerName: 'version',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    minWidth: 200,
    field: 'regDt',
    headerName: '등록일',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    minWidth: 200,
    field: 'modDt',
    headerName: '수정일',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
];
